import moment from 'moment/moment';

export const convertEpochTime = (epochTime: number): string => {
    return new Date(epochTime * 1000).toLocaleString();
};

export const getTodayMMDDYYYY = (): string => {
    const date: moment.Moment = moment();
    return date.format('MM/DD/YYYY');
};

export const convertDateDashToSlash = (dateWithDashes: string): string => {
    const parts = dateWithDashes.split('-');
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
};

export const sleep = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
